module.exports = __webpack_public_path__ + "img/hydol_img02.824ef2ab.png";